

import * as React from 'react';
// tslint:disable:max-line-length
export const deglawySVG: JSX.Element = (
    <svg transform={'rotate(180)'} width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path  d="M1 5.99992H13M5.66667 10.6666L1 5.99992L5.66667 10.6666ZM1 5.99992L5.66667 1.33325L1 5.99992Z" stroke="#FDD72F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
);

export default deglawySVG;
